import React from 'react';
import './style.less';

export default function (props) {
    return (<div className="form-row-root" {...props}/>);
}
